import * as actions from "./servicesPutActions";

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [actions.SERVICES_PUT_REQUEST]: (state, action) => ({
    ...state,
    [action.payload.id]: {
      loading: true,
      loaded: false,
      error: null,
      data: null,
    },
  }),
  [actions.SERVICES_PUT_REQUEST_SUCCESS]: (state, action) => ({
    ...state,
    [action.payload.id]: {
      loading: false,
      loaded: true,
      error: null,
      data: action.data,
    },
  }),
  [actions.SERVICES_PUT_REQUEST_FAILURE]: (state, action) => ({
    ...state,
    [action.payload.id]: {
      loading: false,
      loaded: false,
      error: action.error,
      data: null,
    },
  }),
  [actions.SERVICES_PUT_RESET]: (state, action) => initialState,
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {};

export default function servicesPutReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
